import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const InterviewerService = {
  // Confirmed live shape (api-dev): { success, message, data: { interviews,
  // stats: { upcoming, verdict_pending, completed }, pagination: { total,
  // page, page_size, total_pages, has_next, has_previous } }, error,
  // status_code, error_code }. `stats` is global (all three buckets),
  // present regardless of which single `status` was requested.
  listInterviews: async (
    status,
    page = 1,
    pageSize = 10,
    { search, fromDatetime, toDatetime } = {}
  ) => {
    const endpoint = createEndpoint(API_ENDPOINTS.INTERVIEWER.LIST_INTERVIEWS, {
      status,
      page,
      pageSize,
      search: search || undefined,
      fromDatetime: fromDatetime || undefined,
      toDatetime: toDatetime || undefined,
    });
    const response = await api.get(endpoint);
    return response;
  },

  getBrief: async (interviewRoundDetailId) => {
    const endpoint = createEndpoint(API_ENDPOINTS.INTERVIEWER.GET_BRIEF, {
      interviewRoundDetailId,
    });
    const response = await api.get(endpoint);
    return response;
  },

  getQuestionnaire: async (interviewRoundDetailId) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.INTERVIEWER.GET_QUESTIONNAIRE,
      {
        interviewRoundDetailId,
      }
    );
    const response = await api.get(endpoint);
    return response;
  },

  // payload: { read_inference: 'STRONG'|'MIXED'|'WEAK'|'SKIPPED', comments }
  submitQuestionResponse: async (
    interviewRoundDetailId,
    questionnaireId,
    payload
  ) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.INTERVIEWER.SUBMIT_QUESTION_RESPONSE,
      { interviewRoundDetailId, questionnaireId }
    );
    const response = await api.put(endpoint, payload);
    return response;
  },

  // payload: { final_verdict: 'ADVANCE'|'REJECT'|'HOLD', comments }
  submitVerdict: async (interviewRoundDetailId, payload) => {
    const endpoint = createEndpoint(API_ENDPOINTS.INTERVIEWER.SUBMIT_VERDICT, {
      interviewRoundDetailId,
    });
    const response = await api.post(endpoint, payload);
    return response;
  },

  // { interview_round_detail_id, notes: [{ interviewer_id, interviewer_name, comments }] } —
  // unwrapped down to the caller's own { comments } by useInterviewNotes' `select`.
  getNotes: async (interviewRoundDetailId) => {
    const endpoint = createEndpoint(API_ENDPOINTS.INTERVIEWER.GET_NOTES, {
      interviewRoundDetailId,
    });
    const response = await api.get(endpoint);
    return response;
  },

  // payload: { comments: "markdown notes..." }
  saveNotes: async (interviewRoundDetailId, payload) => {
    const endpoint = createEndpoint(API_ENDPOINTS.INTERVIEWER.PUT_NOTES, {
      interviewRoundDetailId,
    });
    const response = await api.put(endpoint, payload);
    return response;
  },
};
